import { render, staticRenderFns } from "./flashSaleTime.vue?vue&type=template&id=535f013a&scoped=true&"
import script from "./flashSaleTime.vue?vue&type=script&lang=js&"
export * from "./flashSaleTime.vue?vue&type=script&lang=js&"
import style0 from "./flashSaleTime.vue?vue&type=style&index=0&id=535f013a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f013a",
  null
  
)

export default component.exports